// this is ES6 syntax, it's essentially equivalent to: var React =
// require('react')
import React from 'react';
import { reduxForm, Field } from 'redux-form'; // imported Field

//States
import States from 'utils/states.js';

import { normalizeBool, normalizePhone } from 'utils/normalize.js';

import sortBy from 'lodash/sortBy';

//Controls
import Controls from 'utils/renderControl.js';

//Validation function
import validate from './validate';

// hardcode for showcase live const theatres =
// Drupal.settings.showTheatres.concat({ 	house_id: 1620, 	title: "Showcase
// Live" }); const theatres = [ 		{ 				house_id: 1620, 				title: "Showcase
// Live" 		} ];

let theatres;

class PersonalInformation extends React.Component {
  constructor(props) {
    super(props);
  }

  //now this component is getting passed props from the AppContainer
  static propTypes = {
    config: React.PropTypes.object,
    location: React.PropTypes.object,
    onSubmit: React.PropTypes.func,
  };

  componentDidMount() {
    setTimeout(
      function () {
        if (this.props.location.query.validate) {
          const submitter = this.props.handleSubmit(this.props.onSubmit);
          submitter(); // submits
        }
      }.bind(this),
      100
    );

    theatres = this.props.cinemas;
  }

  render() {
    const { handleSubmit, pristine, reset, submitting, config } = this.props;

    return (
      <form id="personal-information" onSubmit={handleSubmit} ref="form">
        <h2 className="no-margin">Personal Information</h2>
        <p>You must be 16+ to work at Showcase Cinemas</p>
        {/************************
         * MOBILE - PREVIOUS/NEXT
         *************************/}
        <div className="actions-mobile clearfix visible-xs-block">
          <button type="submit" disabled={submitting} className="btn">
            Next
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
        {/************************
         * NAME
         *************************/}
        <div className="row">
          <div className="col-sm-12 no-margin required">
            <label>Name</label>
          </div>
        </div>
        <div className="row">
          <Field
            name="firstName"
            type="text"
            wrapperClassName="col-sm-3 required"
            component={Controls.input}
            hideLabel={true}
            props={{
              label: 'First Name',
            }}
          />
          <Field
            name="middleName"
            type="text"
            wrapperClassName="col-sm-3 required"
            component={Controls.input}
            hideLabel={true}
            label={'Middle Name'}
          />
          <Field
            name="lastName"
            type="text"
            wrapperClassName="col-sm-3"
            component={Controls.input}
            hideLabel={true}
            props={{
              label: 'Last Name',
            }}
          />
          <Field
            name="suffix"
            type="text"
            wrapperClassName="col-sm-1 required"
            component={Controls.input}
            hideLabel={true}
            label={'Suff.'}
          />
        </div>
        {/************************
         * ADDRESS
         *************************/}
        <div className="row">
          <div className="col-sm-12 no-margin required">
            <label>Address</label>
          </div>
        </div>
        <div className="row">
          <Field
            name="streetAddress"
            type="text"
            wrapperClassName="col-sm-4"
            hideLabel={true}
            component={Controls.input}
            props={{
              label: 'Street',
            }}
          />
          <Field
            name="city"
            type="text"
            wrapperClassName="col-sm-4"
            hideLabel={true}
            component={Controls.input}
            props={{
              label: 'City',
            }}
          />
          <Field
            name="state"
            wrapperClassName="col-sm-2"
            hideLabel={true}
            component={Controls.select}
            props={{
              label: 'State',
            }}
          >
            {States.map((state) => (
              <option key={state.abbreviation} value={state.abbreviation}>
                {state.name}
              </option>
            ))}
          </Field>

          <Field
            name="zipCode"
            type="text"
            wrapperClassName="col-sm-2"
            hideLabel={true}
            component={Controls.input}
            props={{
              label: 'Zip Code',
            }}
          />
        </div>
        {/************************
         * CONTACT
         *************************/}
        <div className="row">
          <div className="col-sm-12 no-margin required">
            <label>Contact</label>
          </div>
        </div>
        <div className="row">
          <Field
            name="phone"
            type="text"
            wrapperClassName="col-sm-4"
            hideLabel={true}
            component={Controls.input}
            normalize={normalizePhone}
            props={{
              label: '(xxx) xxx - xxxx',
            }}
          />
          <Field
            name="email"
            type="text"
            wrapperClassName="col-sm-4"
            hideLabel={true}
            component={Controls.input}
            props={{
              label: 'Email Address',
            }}
          />
        </div>
        {/************************
         * 18 OR OLDER
         *************************/}
        <div className="row form-age no-caps">
          <Field
            name="eighteenOrOver"
            component={Controls.ageRadio}
            label="Please verify your age:"
            wrapperClassName="col-sm-12"
          />
        </div>
        <hr />{' '}
        {/************************
         * AUTORIZED TO WORK LEGALLY
         *************************/}
        <div className="row legally-work">
          <Field
            name="authorized"
            component={Controls.booleanRadio}
            label="Are you legally authorized to work in the United States?"
            wrapperClassName="col-sm-12"
          />
        </div>
        {/************************
         * WORKED FOR US IN THE PAST
         *************************/}
        <div className="row">
          <label className="col-sm-12 no-caps">
            If you have worked for our company in the past, please state where
            and when:
          </label>
          <Field
            name="employmentTheatre"
            type="number"
            wrapperClassName="col-sm-4"
            component={Controls.select}
            props={{
              placeholder: 'Theatre',
              hideLabel: true,
            }}
          >
            {sortBy(theatres, 'Name').map((theatre) => (
              <option key={theatre.ID} value={theatre.ID}>
                {theatre.Name}
              </option>
            ))}
          </Field>

          <Field
            name="employmentStartDate"
            wrapperClassName="col-sm-4 date"
            component={Controls.date}
            props={{
              placeholder: 'Start Date',
              hideLabel: true,
            }}
          />
          <Field
            name="employmentEndDate"
            wrapperClassName="col-sm-4 date"
            component={Controls.date}
            props={{
              placeholder: 'End Date',
              hideLabel: true,
            }}
          />
        </div>
        {/************************
         * CONVICTED OF A CRIME
         *************************/}
        {/* ONLY SHOW FOR CONFIGURED STATES */}
        {config.askAboutCrime && (
          <div className="row">
            <Field
              name="convicted"
              component={Controls.booleanRadio}
              label="Have you ever been convicted of a crime?"
              wrapperClassName="col-sm-12"
            />

            <Field
              name="convictedDescription"
              wrapperClassName="col-sm-12 no-caps"
              component={Controls.textarea}
              props={{
                placeholder: ' ',
                label: 'If YES, describe in full in below:',
              }}
            />
            <div className="col-sm-12 note-group form-group">
              <em>
                (A conviction will not necessarily bar you from employment)
              </em>
            </div>
          </div>
        )}
        {/************************
         * FRIENDS OR RELATIVES
         *************************/}
        <div className="row">
          <Field
            name="friendsOrRelatives"
            wrapperClassName="col-sm-12 no-caps"
            component={Controls.textarea}
            props={{
              label: 'Please list any friends or relatives employed by us:',
              placeholder: ' ',
              inlineLabel: true,
            }}
          />
        </div>
        {/************************
         * REFRRAL SOURCE
         *************************/}
        <div className="row">
          <Field
            name="referralSource"
            wrapperClassName="col-sm-4 no-caps required"
            component={Controls.select}
            props={{
              label: 'Referral Source',
              placeholder: 'SELECT',
            }}
          >
            <option value="Walk-In">Walk-In</option>
            <option value="Company Employee">Company Employee</option>
            <option value="Community Organization">
              Community Organization
            </option>
            <option value="Other">Other</option>
          </Field>
        </div>
        {/************************
         * PREVIOUS/NEXT
         *************************/}
        <div className="actions">
          <button
            type="submit"
            disabled={submitting}
            className="btn btn-primary"
          >
            Next
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'employment-application',
  destroyOnUnmount: false,
  validate,
})(PersonalInformation);
